class MRecentlyViewed extends HTMLElement {
  constructor() {
    super();
    let e = getCookie("m-recent-viewed-products");
    if (!e) return;
    let t = this.dataset.productHandle;
    (this.productHandles = Array.from(new Set(JSON.parse(e)))),
      t && (this.productHandles = this.productHandles.filter((e) => e !== t)),
      (this.productList = new MinimogTheme.ProductList(
        this,
        this.productHandles
      ));
  }
}
customElements.define("m-recently-viewed", MRecentlyViewed);
